<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="$t('active_sites')"
          :directory="$t('datatables')"
          :icon="'grid'"
        />
      </div>
      <div class="col-sm-12 col-md-6 breadcrumb-side-button">
        <div class="float-md-right mb-3">
          <el-tooltip
            placement="top"
            :effect="themeMode.darkMode == true ? 'light' : 'dark'"
            :content="$t('instruction')">
              <button
              type="button"
              class="btn btn-primary btn-sm"
              data-toggle="modal"
              @click="instructionOpen">
              <!-- {{ $t("instruction") }} -->
              <app-icon name="book-open" />
            </button>
          </el-tooltip>
        </div>
      </div>
      <div class="col-sm-12 col-md-12 col-lg-12 mb-2" v-if="instructionShow == true">
        <div class="alert alert-info" role="alert">
          <button type="button" class="close" @click.prevent="instructionClose">
            <h5 aria-hidden="true">&times;</h5>
          </button>
          <!-- <hr> -->
          <h5 class="alert-heading"><app-icon name="book-open" /> {{ $t("instructions_about_my_site") }}</h5>
          <p class="mb-0">{{ $t("introduction_my_site") }}</p>
          <strong>Actions:</strong>
          <ul>
            <li><strong>{{ $t("view") }} :</strong> {{ $t("view_my_site_detail") }}</li>
          </ul>
        </div>
      </div>
    </div>

    <app-table
      :id="tableId"
      :options="options"
      @action="getListAction"
    />

    <mysite-viewmodal
      v-if="isSiteViewModalActive"
      :id="site_id"
      :table-id="tableId"
      @close-modal="closeSiteViewModal"
    />
  </div>
</template>

<script>
import CoreLibrary from "../../../../../../../core/helpers/CoreLibrary.js";
import * as actions from "../../../../../../Config/ApiUrl";
import { TableHelpers } from "../../../../Demo/Tables/mixins/TableHelpers";

export default {
  extends: CoreLibrary,
  name: "MySiteDataTable",
  mixins: [TableHelpers],

  data() {
    return {
      instructionShow: false,
      site_id: 0,
      siteData: {},
      isSiteViewModalActive: false,
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      selectedUrl: "",
      tableId: "advance-table",
      rowData: {},
      options: {
        name: "AdvanceTable",
        url: actions.MY_SITES,
        showHeader: true,
        columns: [
          {
            title: this.$t("title"),
            type: "custom-html",
            key: "title",
            modifier: (value, row) => {
              return `<a href="#" id="${row.id}" @click=${this.myFunction(row)}>${this.$t(value)}</a>`;

            },
          },
          {
            title: this.$t("description"),
            type: "custom-html",
            key: "description",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("starting_hours"),
            type: "custom-html",
            key: "starting_hours",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("ending_hours"),
            type: "custom-html",
            key: "ending_hours",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
        ],
        actions: [
          {
            title: this.$t("view"),
            icon: "eye",
            type: "none",
          },
        ],
        filters: [
          // {
          //     "title": this.$t('date'),
          //     "type": "range-picker",
          //     "key": "date",
          //     "option": ["today", "thisMonth", "last7Days", "nextYear"]
          // },
          // {
          //     "title": this.$t('age'),
          //     "type": "range-filter",
          //     "key": "age-range",
          //     "maxTitle": this.$t('max_age'),
          //     "minTitle": this.$t('min_age'),
          //     "sign": ""
          // },
          // {
          //     "title": this.$t('status'),
          //     "type": "checkbox",
          //     "key": "status",
          //     "option": [
          //         {id: 'active', value: 'Active'},
          //         {id: 'inactive', value: 'Inactive'},
          //         {id: 'invited', value: 'Invited'},
          //     ],
          // },
          // {
          //     "title": this.$t('gender'),
          //     "type": "radio",
          //     "key": "filter-with-gender",
          //     "option": [
          //         {id: 'male', value: 'Male'},
          //         {id: 'female', value: 'Female'},
          //         {id: 'other', value: 'Other'},
          //     ],
          //     "header": {
          //         "title": this.$t('want_to_filter_your_list'),
          //         "description": this.$t('you_can_filter_your_data_table_which_are_created_based_on_gender'),
          //     },
          // },
          // {
          //     "title": this.$t('search_and_select'),
          //     "type": "drop-down-filter",
          //     "key": "search select",
          //     "option": [],
          // }
        ],
        showFilter: true,
        showSearch: true,
        showCount: true,
        showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
      },
    };
  },
  provide(){
    return{
    siteData: this.getSiteData(),
    }
  },
  created() {
    this.options.columns = [...this.options.columns, this.actionObj];
    // this.searchAndSelectFilterOptions();
  },
  methods: {
    getSiteData(){
      return this.rowData
    },
    instructionOpen() {
      this.instructionShow = true;
    },
    instructionClose() {
      this.instructionShow = false;
    },
    /**
     * for open add edit modal
     */
    openSiteViewModal() {
      this.isSiteViewModalActive = true;
    },

    /**
     * for close add edit modal
     */
    closeSiteViewModal() {
      $("#demo-site-view-Modal").modal("hide");
      this.isSiteViewModalActive = false;
    },
    closeFormAssignModal() {
      $("#package-form-assign-Modal").modal("hide");
      this.isFormAssignModalActive = false;
    },
    closeFormBuilderModal() {
      //   $("#package-form-assign-Modal").modal("hide");
      this.FormBuilderModal = false;
    },
    closeFormViewModal() {
      //   $("#package-forms-view-Modal").modal("hide");
      this.FormViewModal = false;
    },
    setShareData(obj){
      this.$store.commit('updateSharedData', {index: "siteData", newValue: obj})
    },

    /**
     * $emit Form datatable action
     */
    getListAction(rowData, actionObj, active) {
        this.setShareData(rowData)

      if (actionObj.title == this.$t("view")) {
        this.site_id = rowData.id;
        this.openSiteViewModal();
      } 
    //   else if (actionObj.title == this.$t("edit")) {
    //     this.selectedUrl = `${actions.PACKAGE_SHOW}/${rowData.id}`;
    //     this.openAddEditModal();
    //   } else if (actionObj.title == this.$t("assign_form")) {
    //     this.id = rowData.id;
    //     this.isFormAssignModalActive = true;
    //   } else if (actionObj.title == this.$t("Create Form")) {
    //     this.id = rowData.id;
    //     this.FormBuilderModal = true;
    //   }
    //   else if (actionObj.title == this.$t("view_forms")) {
    //     this.pack_id = rowData.id;
    //     this.FormViewModal = true;
    //   }
    },
    view(id) {
          this.site_id = id;
        this.openSiteViewModal();
    },
    myFunction(rowData){
      this.setShareData(rowData);
      let doc = document.getElementById(rowData.id);
      if(doc){
        doc.addEventListener('click', () => {
          this.view(rowData.id)
        }) 
      }
    },
    /**
     * for open confirmation modal
     */
    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },

    /**
     * confirmed $emit Form confirmation modal
     */
    confirmed() {
      let url = `${actions.PACKAGE_DISTROY}/${this.rowData.id}`;
      this.deleteLoader = true;
      this.axiosGet(url)
        .then((response) => {
          this.deleteLoader = false;
          $("#demo-delete").modal("hide");
          this.cancelled();
          this.$toastr.s(response.data.message);
          // this.searchAndSelectFilterOptions();
        })
        .catch(({ error }) => {
          // Trigger after error
        })
        .finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });
    },

    /**
     * cancelled $emit Form confirmation modal
     */
    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },
    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },
    // searchAndSelectFilterOptions() {
    //   this.axiosGet(actions.DATATABLE_SEARCH_SELECT).then((response) => {
    //     let name = this.options.filters.find(
    //       (element) => element.title === this.$t("search_and_select")
    //     );
    //
    //     name.option = response.data.map((name) => {
    //       return {
    //         id: name.name,
    //         value: name.name,
    //       };
    //     });
    //   });
    // },
    //
  },
  computed: {
    themeMode() {
      return this.$store.state.theme;
    },
   },
};
</script>
